var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import ToolBar from "../../parts/ToolBar.vue";
import { WalletsHelper } from "../../../lib/storage";
export default Vue.extend({
    components: { ToolBar },
    name: "WalletLoginImport",
    data() {
        return {
            name: ""
        };
    },
    methods: {
        prohibited() {
            return this.name.length == 0;
        },
        onClickedOk() {
            return __awaiter(this, void 0, void 0, function* () {
                const wallets = yield WalletsHelper.gets();
                const id = wallets[wallets.length - 1].id;
                yield WalletsHelper.setName(id, this.name);
                this.$router.push('/wallet/login/end');
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/wallet/WalletLoginName.vue
// module id = 630
// module chunks = 1